/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // initialise variables
  pmcClientLandlordType: null,
  pmcClientLinkedEnterprise: null,
  pmcClientData: {},
  pmcLandlordsData: [],
  selectedLandlord: '',
  pmcClientAnswers: '',
  pmcLinkedEnterpriseNumber: '',
  companyData: null,
  selectedLandlordClient: {},
  businessVatRegistration: null,
  businessVatData: null,
  pmcCheckAnswers: '',
  pmcAccountEmail: '',
  pmcRepeatAccountEmail: '',
  firstName: '',
  lastName: '',
  roleName: '',
  mobileNumber: '',
  accessCodeMobile: '',
  telephoneNumber: '',
  pmcVerificationCode: '',
  pmcEmailCodeResent: false,
  pmcPasswordValue: '',
  pmcRepeatPasswordValue: '',
  pmcCompanyRegistration: '',
  selectedPMCClientData: {},
};

export const pmcJourneySlice = createSlice({
  name: 'pmcJourney',
  initialState,
  reducers: {
    resetPmcJourney: () => initialState,
    setPmcLandlordType: (state, action) => {
      state.pmcClientLandlordType = action.payload;
    },
    setPmcLinkedEnterprise: (state, action) => {
      state.pmcClientLinkedEnterprise = action.payload;
    },
    setPMCRegistrationNumber: (state, action) => {
      state.pmcClientRegistrationNumber = action.payload;
    },
    setPMCData: (state, action) => {
      state.pmcClientData = action.payload;
    },
    setPMCLandlordsData: (state, action) => {
      state.pmcLandlordsData = action.payload;
    },
    setSelectedLandlord: (state, action) => {
      state.selectedLandlord = action.payload;
    },
    setAnswers: (state, action) => {
      state.pmcClientAnswers = action.payload;
    },
    setPmcLinkedEnterpriseNumber: (state, action) => {
      state.pmcLinkedEnterpriseNumber = action.payload;
    },
    setCompanyData: (state, action) => {
      state.businessVatData = null;
      state.companyData = action.payload;
    },
    setSelectedLandlordClient: (state, action) => {
      state.selectedLandlordClient = action.payload;
    },
    setBusinessVatRegistration: (state, action) => {
      state.businessVatRegistration = action.payload;
    },
    setBusinessVatData: (state, action) => {
      state.companyData = null;
      state.businessVatData = action.payload;
    },
    setPmcCheckAnswers: (state, action) => {
      state.pmcCheckAnswers = action.payload;
    },
    setPmcAccountEmail: (state, action) => {
      state.pmcAccountEmail = action.payload;
    },
    setPmcRepeatAccountEmail: (state, action) => {
      state.pmcRepeatAccountEmail = action.payload;
    },
    setPmcVerificationCode: (state, action) => {
      state.pmcVerificationCode = action.payload;
    },
    setPmcEmailCodeResent: (state, action) => {
      state.pmcEmailCodeResent = action.payload;
    },
    setPmcPasswordValue: (state, action) => {
      state.pmcPasswordValue = action.payload;
    },
    setPmcRepeatPasswordValue: (state, action) => {
      state.pmcRepeatPasswordValue = action.payload;
    },
    setPmcCompanyRegistrationNumber: (state, action) => {
      state.pmcCompanyRegistration = action.payload;
    },
    setAccountFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setAccountLastName: (state, action) => {
      state.lastName = action.payload;
    },
    setAccountRoleName: (state, action) => {
      state.roleName = action.payload;
    },
    setAccountMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
    setAccountTelephoneNumber: (state, action) => {
      state.telephoneNumber = action.payload;
    },
    setAccessCodeMobile: (state, action) => {
      state.accessCodeMobile = action.payload;
    },
    setSelectedPMCClientData: (state, action) => {
      state.selectedPMCClientData = action.payload;
    },
  },
});

export const {
  setPMCRegistrationNumber,
  setPMCData,
  setPMCLandlordsData,
  setSelectedLandlord,
  setPmcLinkedEnterprise,
  setPmcLandlordType,
  setAnswers,
  setPmcLinkedEnterpriseNumber,
  setCompanyData,
  setSelectedLandlordClient,
  setBusinessVatRegistration,
  setBusinessVatData,
  setPmcCheckAnswers,
  setPmcAccountEmail,
  setPmcRepeatAccountEmail,
  setPmcVerificationCode,
  setPmcEmailCodeResent,
  setPmcPasswordValue,
  setPmcRepeatPasswordValue,
  setPmcCompanyRegistrationNumber,
  setAccountFirstName,
  setAccountLastName,
  setAccountRoleName,
  setAccountMobileNumber,
  setAccountTelephoneNumber,
  setAccessCodeMobile,
  resetPmcJourney,
  setSelectedPMCClientData,
} = pmcJourneySlice.actions;
export const getPmcLandlordType = (state) =>
  state.pmcJourney.pmcClientLandlordType;
export const getPmcLinkedEnterprise = (state) =>
  state.pmcJourney.pmcClientLinkedEnterprise;
export const getPMCRegistrationNumber = (state) =>
  state.pmcJourney.pmcClientRegistrationNumber;

export const getAnswers = (state) => state.pmcJourney.pmcClientAnswers;
export const getPMCData = (state) => state.pmcJourney.pmcClientData;
export const getPMCLandlordsData = (state) => state.pmcJourney.pmcLandlordsData;
export const getSelectedLandlord = (state) => state.pmcJourney.selectedLandlord;
export const getPmcLinkedEnterpriseNumber = (state) =>
  state.pmcJourney.pmcLinkedEnterpriseNumber;
export const getCompanyData = (state) => state.pmcJourney.companyData;
export const getSelectedLandlordClient = (state) =>
  state.pmcJourney.selectedLandlordClient;
export const getBusinessVatRegistration = (state) =>
  state.pmcJourney.businessVatRegistration;
export const getBusinessVatData = (state) => state.pmcJourney.businessVatData;
export const getPmcCheckAnswers = (state) => state.pmcJourney.pmcCheckAnswers;
export const getPmcAccountEmail = (state) => state.pmcJourney.pmcAccountEmail;
export const getRepeatAccountEmail = (state) =>
  state.pmcJourney.pmcRepeatAccountEmail;
export const getPmcVerificationCode = (state) =>
  state.pmcJourney.pmcVerificationCode;
export const getPmcEmailCodeResent = (state) =>
  state.pmcJourney.pmcEmailCodeResent;
export const getPmcPasswordValue = (state) => state.pmcJourney.pmcPasswordValue;
export const getPmcRepeatPasswordValue = (state) =>
  state.pmcJourney.pmcRepeatPasswordValue;
export const getPmcCompanyRegistrationNumber = (state) =>
  state.pmcJourney.pmcCompanyRegistration;
export const getAccountFirstName = (state) => state.pmcJourney.firstName;
export const getAccountLastName = (state) => state.pmcJourney.lastName;
export const getAccountRoleName = (state) => state.pmcJourney.roleName;
export const getAccountMobileNumber = (state) => state.pmcJourney.mobileNumber;
export const getAccountTelephoneNumber = (state) =>
  state.pmcJourney.telephoneNumber;
export const getAccessCodeMobile = (state) => state.pmcJourney.accessCodeMobile;
export const getSelectedPMCClientData = (state) =>
  state.pmcJourney.selectedPMCClientData;

export default pmcJourneySlice.reducer;
